import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';import { ActivatedRoute } from '@angular/router';
import { AppService } from '../../../../app/app.service';
import { AddTrainingQuestionComponent } from '../add-training-question/add-training-question.component';
import { QuestionsVM, QuestionTypes, TrainingCatVM, TrainingInfo, TrainingSlidesVM, TrainingSubSectionsVM, TrainingVM } from '../setup-training-types.model';
import { TrainingService } from '../training.service';

@Component({
  selector: 'app-setup-training-questions',
  templateUrl: './setup-training-questions.component.html',
  styleUrls: ['./setup-training-questions.component.scss']
})
export class SetupTrainingQuestionsComponent implements OnInit {
  TrainingId:number=0;
  TrainingCategories: TrainingCatVM[];
  TrainigsList:TrainingVM[];

  TrainingInfo: TrainingInfo;
  SubTrainings: TrainingSubSectionsVM[];
  Slides: TrainingSlidesVM[];
  QuestionTypes:QuestionTypes[];
  TrainingQuestions:QuestionsVM[];

  SelectedQuestionInfo :QuestionsVM;
  constructor(private _route: ActivatedRoute,private _dialog: MatDialog,
    private _appService: AppService, private _trainingService: TrainingService,) { }

  ngOnInit() {
    this._appService.setPageTitle('Setup Training Questions');
    this.TrainingId = Number(this._route.snapshot.params.id);
    
    this.LoadTrainingCatList();
    this.LoadTrainingQuestionsList();
   
    
  }

  LoadTrainingCatList() {
    this._trainingService.GetTrainingTypes().subscribe(res => {
      this.TrainingCategories = res;
      console.log("id", this.TrainingId)

      //this.TrainingId = Number(this._route.snapshot.params.id);
      //this.TrainingId=4;
    })
  }

 
  LoadTrainingQuestionsList(){
    this._trainingService.GetSelectedTrainingSectionAndQuestions(this.TrainingId).subscribe(res => {
      //console.log("result_tarining sections", res)
      this.TrainingInfo = res;
      this.SubTrainings = this.TrainingInfo.SubTrainings;
      this.Slides = this.TrainingInfo.Slides;
      this.QuestionTypes=this.TrainingInfo.QuestionTypes;
      this.TrainingQuestions=this.TrainingInfo.TrainingQuestions;
    });
    
  }

 
  TrainingSelect() {
    if (this.TrainingId > 0) {
      this.LoadTrainingQuestionsList();
    }
  }

  OpenAddQuestion( SectionId: number) {
    let slides = [...this.Slides];
    let filterSlides = slides.filter(x=>x.SubSectionId==SectionId);
    //let slides = this.Slides.filter(x=>x.SubSectionId==SectionId);
    
    console.log('slides', slides)
    const addSectionDialog = this._dialog.open(AddTrainingQuestionComponent, {
      width: '700px',
      height:'890px',
      data: {
        TrainingId: this.TrainingId,
        SectionId: SectionId,
        isAddQuestion: true,
        Slides:filterSlides,
        QuestionTypes:this.QuestionTypes,
      }
    });
    addSectionDialog.afterClosed().subscribe(details => {
      if (details == true) {
        this.LoadTrainingQuestionsList();
      }
    });
  }

  toggleQuestion(QId:number, Status:boolean){
    this._trainingService.TogglelTrainingQuestion(QId,Status).subscribe(res=>{
      this.LoadTrainingQuestionsList();
    })
  }
  

  OrderUP_Q(order:number, sectionId:number){
    this._trainingService.OrderUp_TrainingQuestion(order,sectionId).subscribe(res=>{
      this.LoadTrainingQuestionsList();
    })
  }
  OrderDown_Q(order:number, sectionId:number){
    this._trainingService.OrderDown_TrainingQuestion(order,sectionId).subscribe(res=>{
      this.LoadTrainingQuestionsList();
    })
  }

  OpenEditQuestion(SectionId:number,QuestionId:number){
    this._trainingService.GetSelectedQuestionInfo(QuestionId).subscribe(res=>{
      console.log("Question", res)
      this.SelectedQuestionInfo = res;
      let slides = [...this.Slides];
      let filterSlides = slides.filter(x=>x.SubSectionId==SectionId);
      const addSectionDialog = this._dialog.open(AddTrainingQuestionComponent, {
        width: '700px',
        height:'890px',
        data: {
          TrainingId: this.TrainingId,
          SectionId: SectionId,
          isEditQuestion: true,
          Slides:filterSlides,
          QuestionTypes:this.QuestionTypes,
          SelectedQuestionInfo:this.SelectedQuestionInfo
        }
      });
      addSectionDialog.afterClosed().subscribe(details => {
        if (details == true) {
          this.LoadTrainingQuestionsList();
        }
      });

    })
  }
}
